/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  EntityId,
  InviteUsersAndTeams,
  List,
  MemberRole,
  MemberRoleOrGuest,
  OrganizationTeam,
  UserContentPermission,
} from "./data-contracts";

/**
 * No description
 * @tags space-permissions
 * @name InviteToSpace
 * @summary Invite a user or a team to a space
 * @request POST:/spaces/{spaceId}/permissions
 * @secure
 */

// @ts-ignore
export const inviteToSpace: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {};
  RequestBody: InviteUsersAndTeams;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/spaces/{spaceId}/permissions",
  method: "post",
  streaming: false,
  tags: ["space-permissions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-permissions
 * @name UpdateTeamPermissionInSpace
 * @summary Update an org team's permission in a space
 * @request PATCH:/spaces/{spaceId}/permissions/teams/{teamId}
 * @secure
 */

// @ts-ignore
export const updateTeamPermissionInSpace: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the Team */
    teamId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    /** The role of a member in an organization, null for guests */
    role?: MemberRoleOrGuest;
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/spaces/{spaceId}/permissions/teams/{teamId}",
  method: "patch",
  streaming: false,
  tags: ["space-permissions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-permissions
 * @name RemoveTeamFromSpace
 * @summary Remove an org team from a space
 * @request DELETE:/spaces/{spaceId}/permissions/teams/{teamId}
 * @secure
 */

// @ts-ignore
export const removeTeamFromSpace: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the Team */
    teamId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205 | 400;
} = {
  route: "/spaces/{spaceId}/permissions/teams/{teamId}",
  method: "delete",
  streaming: false,
  tags: ["space-permissions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-permissions
 * @name ListUserPermissionsInSpace
 * @summary List space user permissions
 * @request GET:/spaces/{spaceId}/permissions/users
 * @secure
 */

// @ts-ignore
export const listUserPermissionsInSpace: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: UserContentPermission[];
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/spaces/{spaceId}/permissions/users",
  method: "get",
  streaming: false,
  tags: ["space-permissions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-permissions
 * @name UpdateUserPermissionInSpace
 * @summary Update space user permissions
 * @request PATCH:/spaces/{spaceId}/permissions/users/{userId}
 * @secure
 */

// @ts-ignore
export const updateUserPermissionInSpace: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The role of a member in an organization, null for guests */
    role?: MemberRoleOrGuest;
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/spaces/{spaceId}/permissions/users/{userId}",
  method: "patch",
  streaming: false,
  tags: ["space-permissions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-permissions
 * @name RemoveUserFromSpace
 * @summary Remove a space user
 * @request DELETE:/spaces/{spaceId}/permissions/users/{userId}
 * @secure
 */

// @ts-ignore
export const removeUserFromSpace: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/spaces/{spaceId}/permissions/users/{userId}",
  method: "delete",
  streaming: false,
  tags: ["space-permissions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-permissions
 * @name ListTeamPermissionsInSpace
 * @summary List an org team's permission in a space
 * @request GET:/spaces/{spaceId}/permissions/teams
 * @secure
 */

// @ts-ignore
export const listTeamPermissionsInSpace: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: {
      /**
       * "The role of a member in an organization.
       * "admin": Can administrate the content: create, delete spaces, ...
       * "create": Can create content.
       * "review": Can review content.
       * "edit": Can edit the content (live or change requests).
       * "comment": Can access the content and its discussions.
       * "read": Can access the content, but cannot update it in any way.
       */
      permission: MemberRole;
      team: OrganizationTeam;
    }[];
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/spaces/{spaceId}/permissions/teams",
  method: "get",
  streaming: false,
  tags: ["space-permissions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-permissions
 * @name ListPermissionsAggregateInSpace
 * @summary List all space users permissions
 * @request GET:/spaces/{spaceId}/permissions/aggregate
 * @secure
 */

// @ts-ignore
export const listPermissionsAggregateInSpace: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** If defined, only members with this role will be returned. */
    role?: MemberRole;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: UserContentPermission[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/permissions/aggregate",
  method: "get",
  streaming: false,
  tags: ["space-permissions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-permissions
 * @name ListPermissionsAggregateInCollection
 * @summary List all collections users permissions
 * @request GET:/collections/{collectionId}/permissions/aggregate
 * @secure
 */

// @ts-ignore
export const listPermissionsAggregateInCollection: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the collection */
    collectionId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** If defined, only members with this role will be returned. */
    role?: MemberRole;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: UserContentPermission[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/collections/{collectionId}/permissions/aggregate",
  method: "get",
  streaming: false,
  tags: ["space-permissions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
